// ABOUTME: Initializes expandable textarea and popovers on connect.
// ABOUTME: Replaces SJR-based bindExpandableTextarea() and .popover() calls.

import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    var textarea = $(this.element).find('.expandable-textarea')
    if (textarea.length) {
      new MediaAssetAction().bindExpandableTextarea(textarea)
    }
    $(this.element).find('[data-toggle="popover"]').popover()
  }
}
